import { render } from "./roomBooks.vue?vue&type=template&id=24589bf7&scoped=true"
import script from "./roomBooks.vue?vue&type=script&lang=js"
export * from "./roomBooks.vue?vue&type=script&lang=js"

import "./roomBooks.vue?vue&type=style&index=0&id=24589bf7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24589bf7"]])

export default __exports__